module.exports = __webpack_public_path__ + "static/BTP_testimonials-d3b8c5352ba8262dcc9b93f21ddfd543.png";